// GA4 Event Names and Configuration Constants

export const GA4_EVENT_NAMES = {
  // Session events
  SESSION_START: 'session_start',
  SESSION_END: 'session_end',
  
  // Instrument events
  INSTRUMENT_SELECT: 'instrument_select',
  INSTRUMENT_CHANGE: 'instrument_change',
  PRESET_APPLY: 'preset_apply',
  
  // Parameter events
  PARAMETER_ADJUST: 'parameter_adjust',
  PARAMETER_COMPLETE: 'parameter_complete',
  CUSTOM_PARAMS_TOGGLE: 'custom_params_toggle',
  
  // Grid events
  GRID_CELL_TOGGLE: 'grid_cell_toggle',
  NOTE_PITCH_CHANGE: 'note_pitch_change',
  GRID_DRAG: 'grid_drag',
  ROW_ACTION: 'row_action',
  
  // Playback events
  PLAYBACK_START: 'playback_start',
  PLAYBACK_STOP: 'playback_stop',
  BPM_CHANGE: 'bpm_change',
  
  // Composition events
  COMPOSITION_EXPORT: 'composition_export',
  COMPOSITION_SAVE_LOAD: 'composition_save_load',
  
  // AI events
  AI_GENERATION_START: 'ai_generation_start',
  AI_GENERATION_COMPLETE: 'ai_generation_complete',
  AI_GENERATION_ERROR: 'ai_generation_error',
  
  // Mixing events
  VOLUME_ADJUST: 'volume_adjust',
  MUTE_TOGGLE: 'mute_toggle',
  
  // Template events
  TEMPLATE_LOAD: 'template_load',
  TEMPLATE_SAVE: 'template_save',
} as const;

// Configuration Defaults
export const DEFAULT_CONFIG = {
  DEBOUNCE_MS: 500,
  THROTTLE_MS: 1000,
  MAX_QUEUE_SIZE: 100,
  SESSION_TIMEOUT_MS: 30 * 60 * 1000, // 30 minutes
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY_MS: 1000,
  EVENT_BATCH_SIZE: 10,
} as const;

// PII Detection Patterns
export const PII_PATTERNS = {
  email: /\b[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Z|a-z]{2,}\b/g,
  phone: /\b\d{3}[-.]?\d{3}[-.]?\d{4}\b/g,
  ssn: /\b\d{3}-\d{2}-\d{4}\b/g,
  creditCard: /\b\d{4}[-\s]?\d{4}[-\s]?\d{4}[-\s]?\d{4}\b/g,
} as const;

// Local Storage Keys
export const STORAGE_KEYS = {
  OPT_OUT: 'analytics_opt_out',
  SESSION_ID: 'analytics_session_id',
  SESSION_START: 'analytics_session_start',
} as const;

// GA4 Limits
export const GA4_LIMITS = {
  EVENT_NAME_MAX_LENGTH: 40,
  PARAM_NAME_MAX_LENGTH: 40,
  PARAM_VALUE_MAX_LENGTH: 100,
} as const;
